module.exports = [
  require('./water_walk'),
  require('./weird'),
  require('./wind_walk'),
  require('./wish'),
  require('./witch_bolt'),
  require('./word_of_recall'),
  require('./wrathful_smite'),
]
